module.exports = __webpack_public_path__ + "static/media/icon-06.969e0013.png";